module.exports = __webpack_public_path__ + "img/avnon-1.55e661bc.jpg";